import { useState, useEffect } from "react";
import { FaShareAlt, FaWhatsapp } from "react-icons/fa";
import EnquiryDialog from "./EnquiryDialog";

const EnquiryCell = ({ price, name, eventId, dateList }) => {
  const [isSticky, setIsSticky] = useState(false);
  const [isDialogOpen, setDialogOpen] = useState(false);
  let encodedData = encodeURIComponent(
    `Hi! I'd like to quickly inquire about the details.\n*${name}*\nName: \nPhone Number: \nHead Count: `,
  );

  const copyText = () => {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => alert("Copied!"))
      .catch((err) => console.error("Failed to copy: ", err));
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 300); // Adjust threshold as needed
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`enquiry-cell ${isSticky ? "sticky" : ""}`}>
      <p className="price">{!price ? "Contact for details" : `₹${price}`}</p>
      <div className="when-small-screen">
        {/* <button
          onClick={() => setDialogOpen(!isDialogOpen)}
          className="enquiry-btn"
        >
          Enquire Now
        </button> */}
        <div className="button-container">
          <button onClick={copyText} className="icon-btn share-btn">
            <FaShareAlt />
          </button>
          <a
            href={`https://wa.me/919372121718?text=${encodedData}`}
            target="_blank"
            rel="noopener noreferrer"
            className="icon-btn whatsapp-btn"
          >
            <FaWhatsapp />
          </a>
        </div>
      </div>
      <EnquiryDialog
        isOpen={isDialogOpen}
        onClose={() => setDialogOpen(false)}
        name={name}
        eventId={eventId}
        dateList={dateList}
      />
    </div>
  );
};

export default EnquiryCell;
